import { app } from '../../app.module'
app
  // 一括タグ管理モーダル用のパネル
  .directive('batchTagAllCheckbox', () => {
    return {
      restrict: 'E',
      template: require('./batch-tag-all-checkbox.pug')(),
      controller: function ($scope) {
        // 一括でチェックを入れた際に、チェックが入る総数
        let checkNum = $scope.query.limit

        // チェックが入る総数をインクリメントする
        $scope.$on('removeCheck', () => {
          if (checkNum < $scope.query.limit) {
            checkNum = checkNum + 1
          }

          // チェックされた項目が一件もない場合は、チェックをOffにする
          if (checkNum === $scope.query.limit) {
            $scope.checkbox = false
          }
        })

        // チェックが入る総数をデクリメントする
        $scope.$on('addCheck', () => {
          checkNum = checkNum - 1

          // 個別のチェックボックスに1つでもチェックが入った場合は、チェックをOnにする
          $scope.checkbox = true
        })

        // 選択解除ボタンが押された際に、チェックボックスのチェックを空にする
        $scope.$on('resetCheckBox', () => {
          $scope.checkbox = false
        })

        // ページング移動の際に、チェックボックスのチェックを空にする
        $scope.$on('onPaginate', () => {
          $scope.checkbox = false
          // チェック総数をリセットする
          checkNum = $scope.query.limit
        })
        /**
         * チェックボックスに変更が加えられた場合は、チェックのOn/Off情報と共に、イベントを送信する
         * @param  {boolean} checkbox チェックをつけた場合はtrue, 外した場合はfalse
         */
        $scope.check = function (checkbox: boolean) {
          // 一括で処理できる上限を設ける。上限以上のチェックが入る場合は、警告を表示する
          const checkLimit = 50

          if (checkbox === true && $scope.selectedIds.length + checkNum > checkLimit) {
            alert(checkLimit + '項目以上、同時に選択することはできません。')
          }
          $scope.$broadcast('changeCheck', checkbox)
        }
      },
    }
  })
